import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import ReactJsonView from "@microlink/react-json-view";
import type { JsonModalAction } from "@src/services/state/layoutReducer";
import { useDarkMode } from "@tradingdroid/frontends-components";

interface Props {
  data: Record<string, any>;
  title?: string;
  onClose: () => void;
  actions?: JsonModalAction[];
}

export const JsonModal: React.FC<Props> = ({ data, title, onClose, actions }) => {
  const { isDark } = useDarkMode();

  return (
    <CModal
      className="JsonModal"
      title={title} //
      size="lg"
      visible={Object.keys(data).length > 0}
      onClose={onClose}
    >
      <CModalHeader closeButton>
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>

      <CModalBody>
        <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
          <ReactJsonView
            src={data}
            name={false}
            theme={isDark ? "monokai" : "rjv-default"}
            displayDataTypes={false}
          />
        </pre>
      </CModalBody>

      <CModalFooter style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          {actions?.map((action) => (
            <CButton
              key={action.id ?? action.label}
              color={action.type || "primary"}
              onClick={() => action.onClick(data)}
            >
              {action.label}
            </CButton>
          ))}
        </div>

        <CButton color="secondary" onClick={onClose}>
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  );
};
